{
  "apiData": {
    "title": "Api Data",
    "stationTitle": "Chargers",
    "sessionTitle": "Sessions",
    "chartTitle": "Charts",
    "apiDataSearch": "Search",
    "selectColumns": "Select Columns",
    "columnSettings": "Columns Settings",
    "sessionsView": "Sessions",
    "chargersView": "Chargers",
    "chartView": "Charts",
    "download": "Download",
    "perPage": "per page",
    "timeframe": "Timeframe",
    "range": "Range",
    "rangeHelperText": "After start date",
    "startRange": "Start Range",
    "endRange": "End Range",
    "stations": "Stations",
    "timeframe_days": "Days",
    "timeframe_months": "Months",
    "timeframe_quarters": "Quarters",
    "timeframe_years": "Years",
    "range_current": "Current",
    "range_days90": "90 days",
    "range_months6": "6 months",
    "range_year1": "1 year",
    "range_year2": "2 years",
    "range_year3": "3 years",
    "range_year4": "4 years",
    "range_year5": "5 years",
    "range_year6": "6 years",
    "range_year7": "7 years",
    "range_custom": "Custom",
    "totalEnergy": "Total Energy (kWh)",
    "notificationStationSelect": "You must select stations first to see the charts",
    "startDateFilter": "Date Range From",
    "endDateFilter": "Date Range To",
    "chargingNetworkFilter": "Charging Network",
    "chargerLevelFilter": "Charger Level",
    "subOrganizationFilter": "Sub-Organization",
    "serialNumberFilter": "Serial Number",
    "serialNumberSearchHint": "Type at least {{min}} characters to search",
    "filtersDisclaimer": "Leaving a filter unselected includes all of its options.",
    "stateFilter": "State/Province",
    "searchFilters": "SEARCH",
    "noFilters": "Select filters and click Search to load data!",
    "noData": "No data found",
    "noColumns": "No columns selected. Use the column settings to choose which columns to show."
  }
}
